import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import * as React from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

interface Review {
  name: string;
  rating: number;
  review: string;
}

const reviews: Review[] = [
  {
    "name": "Selin Karaca",
    "rating": 5,
    "review": "Daha önce başka yerlerden koçluk almıştım ama hiç bu kadar faydalı olmamıştı. Nur abla sayesinde gerçekten çalışmanın ne demek olduğunu öğrendim. Aldığım destek netlerime hızlıca etki etti. Koçum ders çalışma programımı planlamada ve motivasyonumu korumada çok yardımcı oldu. Kendimi daha disiplinli ve motive hissediyorum. Çok teşekkür ederim! ❤️"
  },
  {
    "name": "Burak Mert Eroğlu",
    "rating": 5,
    "review": "Başlangıçta biraz tereddütlüydüm ama şimdi iyi ki Kampüs Mentörlük'le tanışmışım diyorum. Koçum haftalık programlarımı hazırlamak dışında da beni hep takip ediyor. Ayrıca Kampüs Mentörlük ekibi de memnun olup olmadığımı hep soruyorlar. Desteklerini hep hissetmek bana güven veriyor masa başına daha kolay geçiyorum. Cansınızz"
  },
  {
    "name": "Eray Akçalı",
    "rating": 5,
    "review": "Sınava 4. kez gireceğim. İyi ki Oğuzhan'la tanışmışım yoksa bir kez daha girmem gerekebilirdi. Oğuzhan özellikle zorlandığım konuları saptamamda ve onlara odaklanmamda çok yardımcı oldu. Sürece nasıl bakmam gerektiğini öğretti, artık kendi kendime oturup çalışmakta zorlanmıyorum. Bu alışkanlığı benim gibi bir öğrenciye bile kazandırdıysa herkese kazandırır."
  },
  {
    "name": "Tolga Akbaba",
    "rating": 4,
    "review": "Koçluk hizmeti oldukça iyi, ancak yeni yılda zam yaptılar ekonomik şartlardan dolayı. Eski ücretten devam edebilsek harika olurdu. Ama yine de genel olarak çok memnunum, teşekkürler"
  },
  {
    "name": "Dilara Mumcu",
    "rating": 5,
    "review": "İlk defa koçluk aldım. Oğuzhan abinin kanalından görüp bir deneyeyim demiştim. Başlarken tytde 50-55 civarı netler yapıyordum, başlayalı 2,5 ay oldu son netim 83. Yorumu size bırakıyorum."
  },
  {
    "name": "Muhammed Yasin Tunç",
    "rating": 5,
    "review": "Sayenizde 7 haftada 20 net artırdım, sınava kadar da devam edeceğim. İnşallah başarıp hayalime kavuşacağım"
  },
  {
    "name": "Şeyda Arslan",
    "rating": 5,
    "review": "Koçluk hizmeti beklentilerimin çok ötesindeydi. Hem ders çalışma programı hem de motivasyon açısından çok yardımcı oldular. Tüm öğrencilere tavsiye ederim."
  },
  {
    "name": "Doğa Onuk",
    "rating": 5,
    "review": "Annemin zoruyla başladığım koçluk görüşmelerine şimdi heyecanla giriyorum. Her denemeden sonra Hazal ablaya netimi atınca bi ders çalışma isteği geliyo. Umarım hedeflerime kavuşup YKS sonucumu da atıyor olurum."
  },
  {
    "name": "Elif Kuday",
    "rating": 5,
    "review": "Herkese öneririm, harika bir mentörlük deneyimi! Süreç boyunca kendimi güvende ve doğru yolda hissettim. Çok teşekkür ederim."
  }
];

export const ReviewsSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    loop: true,
    dragFree: true,
    containScroll: "trimSnaps"
  }, [
    Autoplay({
      delay: 4000,
      stopOnInteraction: false,
      stopOnMouseEnter: true
    })
  ]);

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Öğrencilerimizin Yorumları
          </h2>
          <p className="text-brand-primary/70 max-w-2xl mx-auto">
            Kampüs Mentörlük'ten faydalanan öğrencilerimizin deneyimlerini dinleyin.
          </p>
        </div>

        <div className="overflow-hidden relative" ref={emblaRef}>
          <div className="flex -ml-2 md:-ml-4">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="pl-2 md:pl-4 min-w-full sm:min-w-[50%] lg:min-w-[25%]"
              >
                <div className={cn(
                  "bg-white p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg h-full",
                  "border border-gray-100 hover:border-brand-primary/20"
                )}>
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-brand-primary/10 rounded-full flex items-center justify-center mr-4">
                      <span className="text-brand-primary font-semibold text-lg">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">{review.name}</h3>
                      <div className="flex items-center">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <Star
                            key={i}
                            className="w-4 h-4 fill-yellow-400 text-yellow-400"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-brand-primary/70 leading-relaxed line-clamp-6">{review.review}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="hidden md:block">
          <button
            onClick={() => emblaApi?.scrollPrev()}
            className="absolute -left-12 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-50"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={() => emblaApi?.scrollNext()}
            className="absolute -right-12 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-50"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};